import { settings as en_settings } from "../en/settings";

/** settings — ES slice (55 keys). */
export const settings: Record<keyof typeof en_settings, string> = {
  settings_account_section_title: "Cuenta",
  settings_email_title: "Correo",
  settings_email_subtitle: "Cambia tu correo electrónico",
  settings_preferences_section_title: "Preferencias",
  settings_language_title: "Idioma",
  settings_language_subtitle: "Idioma de la aplicación",
  settings_push_notifications_title: "Notificaciones push",
  settings_push_notifications_subtitle:
    "Recibe notificaciones en tu dispositivo",
  settings_push_notifications_test_title: "Probar notificación push",
  settings_push_notifications_test_description:
    "Envía una alerta de prueba para confirmar que las notificaciones push funcionan en este dispositivo.",
  settings_push_notifications_test_disabled_hint:
    "Activa las notificaciones push de arriba para enviar una prueba.",
  settings_push_notifications_test_button: "Enviar notificación de prueba",
  settings_push_notifications_test_button_loading: "Enviando...",
  settings_dark_mode_title: "Modo oscuro",
  settings_dark_mode_subtitle: "Usar tema oscuro",
  settings_legal_support_section_title: "Legal y soporte",
  settings_about_us_title: "Sobre nosotros",
  settings_about_us_subtitle: "Conoce más sobre Linqx",
  settings_about_version: "Versión",
  settings_about_description:
    "Linqx te ayuda a conocer gente cerca y convertir tus matches en planes reales.",
  settings_about_visit_website: "Visitar el sitio web",
  settings_privacy_policy_title: "Política de privacidad",
  settings_privacy_policy_subtitle: "Cómo protegemos tus datos",
  settings_terms_of_use_title: "Términos de uso",
  settings_terms_of_use_subtitle: "Lee nuestros términos y condiciones",
  settings_app_version_title: "Versión de la app",
  settings_logout_button: "Cerrar sesión",
  settings_logout_confirmation_title: "Cerrar sesión",
  settings_logout_confirmation_message: "¿Seguro que quieres cerrar sesión?",
  settings_logout_confirmation_confirm: "Cerrar sesión",
  settings_email_current_email_title: "Correo actual",
  settings_email_new_email_title: "Nuevo correo electrónico",
  settings_email_address_label: "Correo electrónico",
  settings_email_address_placeholder: "Introduce el nuevo correo",
  settings_email_update_button: "Actualizar correo",
  settings_email_updating_button: "Actualizando...",
  settings_email_info_message:
    "Tendrás que verificar tu nuevo correo antes de que el cambio se aplique. Te enviaremos un correo de verificación a la nueva dirección.",
  settings_success_title: "Éxito",
  settings_success_email_updated: "Correo actualizado correctamente",
  settings_success_billing_updated:
    "Dirección de facturación actualizada correctamente",
  settings_error_invalid_email: "Introduce un correo electrónico válido",
  settings_error_fill_required_fields: "Completa todos los campos obligatorios",
  settings_ok_button: "OK",
  notifications_success_title: "Éxito",
  notifications_success_settings_updated:
    "Ajustes de notificaciones actualizados correctamente",
  notifications_success_token_registered:
    "Notificaciones push registradas correctamente",
  notifications_success_token_updated: "Token push actualizado correctamente",
  notifications_success_token_deleted: "Token push eliminado correctamente",
  notifications_success_test_scheduled:
    "Notificación de prueba programada correctamente",
  notifications_error_title: "Error",
  notifications_error_update_failed:
    "No se pudieron actualizar los ajustes de notificaciones",
  notifications_error_register_failed:
    "No se pudieron registrar las notificaciones push",
  notifications_error_delete_failed: "No se pudo eliminar el token push",
  notifications_error_not_supported:
    "Las notificaciones push no son compatibles con este dispositivo",
  notifications_error_permission_denied: "Permiso de notificaciones denegado",
  notifications_error_test_failed:
    "No se pudo enviar la notificación de prueba",
  notifications_confirm_delete_title: "Eliminar token push",
  notifications_confirm_delete_message:
    "¿Seguro que quieres eliminar este token push?",
  notifications_confirm_delete_cancel: "Cancelar",
  notifications_confirm_delete_confirm: "Eliminar",
  settings_danger_section_title: "Zona de peligro",
  settings_deactivate_title: "Desactivar cuenta",
  settings_deactivate_subtitle:
    "Oculta tu perfil y cierra sesión. Es reversible.",
  settings_deactivate_confirm_title: "¿Desactivar cuenta?",
  settings_deactivate_confirm_message:
    "Tu perfil se ocultará en todas partes y se cerrará tu sesión en todos los dispositivos. Puedes reactivarla volviendo a iniciar sesión.",
  settings_deactivate_confirm_confirm: "Desactivar",
  settings_deactivate_error: "No se pudo desactivar. Inténtalo de nuevo.",
};
